import axios from 'axios';
import store from '@/store';
import { getAccessToken, getRefreshToken, getLoggedUser } from '@/utils/auth';

const service = axios.create({
  baseURL: process.env.BASE_API,
  timeout: 30000
});

service.interceptors.request.use(
  config => {
    if (store.getters.token) {
      config.headers['Authorization'] = `Bearer ${getAccessToken()}`;
    }
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

service.interceptors.response.use(
  response => response,
  error => {
    const originalRequest = error.config;

    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const accessToken = getAccessToken();
      const refreshToken = getRefreshToken();
      const loggedUser = getLoggedUser();

      if (!accessToken && !refreshToken && !loggedUser) {
        window.location.href = '/#/login';
      } else {

        return service
          .get(`/user/refreshToken?refreshToken=${refreshToken}`)
          .then(res => {
            let token = res.data.data.json;
            if (token.access_token && token.refresh_token) {
              store.commit('SET_TOKEN', token);
              axios.defaults.headers.common['Authorization'] =
                'Bearer ' + token.access_token;
              originalRequest.headers['Authorization'] =
                'Bearer ' + token.access_token;

              window.location.reload();
            }
            else {
              setTimeout(() => {
                window.location.href = '/#/login';
              }, 3000);
            }
          });
      }
    }  

    // try {
    // } catch (error) {
    //   window.location.href = '/#/login';
    // }

    if (error.response.status === 500) {
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/api/request.js